document.documentElement.classList.add('js');

document.addEventListener('click', (event) => {
  const swatch = event.target.closest('[data-card-swatch]');
  if (swatch) {
    const card = swatch.closest('[data-product-card]');
    card?.querySelectorAll('[data-card-swatch]').forEach((item) => item.classList.toggle('is-active', item === swatch));
    const image = card?.querySelector('[data-card-primary]');
    if (image && swatch.dataset.image) { image.removeAttribute('srcset'); image.src = swatch.dataset.image; }
    return;
  }
  const sizeGuideOpen = event.target.closest('[data-size-guide-open]');
  if (sizeGuideOpen) document.querySelector('[data-size-guide]')?.showModal();
  const sizeGuideClose = event.target.closest('[data-size-guide-close]');
  if (sizeGuideClose) document.querySelector('[data-size-guide]')?.close();
  const trigger = event.target.closest('[data-menu-toggle]');
  if (trigger) {
    const menu = document.querySelector('[data-mobile-menu]');
    const open = menu?.toggleAttribute('data-open') || false;
    trigger.setAttribute('aria-expanded', String(open));
  }
  const mobileMenu = document.querySelector('[data-mobile-menu][data-open]');
  if (!trigger && mobileMenu && (!mobileMenu.contains(event.target) || event.target.closest('a'))) {
    mobileMenu.removeAttribute('data-open');
    document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
  }
  const close = event.target.closest('[data-drawer-close]');
  if (close) close.closest('[data-drawer]')?.removeAttribute('data-open');
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('[data-mobile-menu][data-open]');
  if (!menu) return;
  menu.removeAttribute('data-open');
  const toggle = document.querySelector('[data-menu-toggle]');
  toggle?.setAttribute('aria-expanded', 'false');
  toggle?.focus();
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-quick-add-form]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('[data-quick-add-button]');
  if (!button || button.disabled) return;
  const initialText = button.textContent;
  button.disabled = true; button.textContent = 'AJOUT...';
  try {
    const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    if (!response.ok) throw new Error('cart');
    button.textContent = 'AJOUTÉ';
    const cart = await (await fetch('/cart.js')).json();
    document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
  } catch (error) { button.textContent = 'RÉESSAYER'; }
  window.setTimeout(() => { button.disabled = false; button.textContent = initialText; }, 1800);
});

document.addEventListener('click', (event) => {
  const tab = event.target.closest('[data-size-tab]');
  if (!tab) return;
  const guide = tab.closest('[data-size-guide]');
  guide.querySelectorAll('[data-size-tab]').forEach((item) => item.classList.toggle('is-active', item === tab));
  guide.querySelectorAll('[data-size-panel]').forEach((panel) => { panel.hidden = panel.dataset.sizePanel !== tab.dataset.sizeTab; });
});

document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-variant-select]')) return;
  const option = event.target.selectedOptions[0];
  const form = event.target.closest('form');
  form?.querySelector('[name="id"]')?.setAttribute('value', option.value);
  const price = document.querySelector('[data-product-price]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
  const button = form?.querySelector('[type="submit"]');
  if (button) {
    button.disabled = option.dataset.available !== 'true';
    button.textContent = option.dataset.available === 'true' ? button.dataset.availableText : button.dataset.soldoutText;
  }
});

document.querySelectorAll('[data-calendar]').forEach((calendar) => {
  const grid = calendar.querySelector('[data-calendar-grid]');
  const monthLabel = calendar.querySelector('[data-calendar-month]');
  const eventCards = Array.from(calendar.querySelectorAll('[data-event-card]'));
  const filterButtons = Array.from(calendar.querySelectorAll('[data-calendar-filter]'));
  const months = ['JANVIER','FÉVRIER','MARS','AVRIL','MAI','JUIN','JUILLET','AOÛT','SEPTEMBRE','OCTOBRE','NOVEMBRE','DÉCEMBRE'];
  let activeFilter = 'all';
  const today = new Date(); today.setHours(12,0,0,0);
  const datedEvents = eventCards.map((card) => {
    const date = new Date(card.dataset.eventDate + 'T12:00:00');
    const parsedEndDate = new Date((card.dataset.eventEndDate || card.dataset.eventDate) + 'T12:00:00');
    const endDate = Number.isNaN(parsedEndDate.getTime()) || parsedEndDate < date ? date : parsedEndDate;
    return { card, date, endDate, type: card.dataset.eventType, title: card.dataset.eventTitle, place: card.dataset.eventPlace, flag: card.dataset.eventFlag || '🏳️' };
  }).filter((item) => !Number.isNaN(item.date.getTime()));
  const nextEvent = datedEvents.find((item) => item.endDate >= today) || datedEvents[0];
  let cursor = nextEvent ? new Date(nextEvent.date.getFullYear(), nextEvent.date.getMonth(), 1) : new Date(today.getFullYear(), today.getMonth(), 1);

  const render = () => {
    if (!grid || !monthLabel) return;
    monthLabel.textContent = `${months[cursor.getMonth()]} ${cursor.getFullYear()}`;
    grid.innerHTML = '';
    const first = new Date(cursor.getFullYear(), cursor.getMonth(), 1);
    const startOffset = (first.getDay() + 6) % 7;
    const start = new Date(first); start.setDate(first.getDate() - startOffset);
    for (let index = 0; index < 42; index += 1) {
      const date = new Date(start); date.setDate(start.getDate() + index);
      date.setHours(12,0,0,0);
      const iso = [date.getFullYear(), String(date.getMonth()+1).padStart(2,'0'), String(date.getDate()).padStart(2,'0')].join('-');
      const cell = document.createElement('div');
      cell.className = 'calendar-day';
      if (date.getMonth() !== cursor.getMonth()) cell.classList.add('is-outside');
      if (date.getTime() === today.getTime()) cell.classList.add('is-today');
      cell.innerHTML = `<span class="calendar-day__number">${date.getDate()}</span><div class="calendar-day__events"></div>`;
      const slot = cell.querySelector('.calendar-day__events');
      datedEvents.filter((item) => date >= item.date && date <= item.endDate && (activeFilter === 'all' || item.type === activeFilter)).forEach((item) => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'calendar-event'; button.dataset.type = item.type;
        button.textContent = `${item.flag} ${item.title}`; button.title = `${item.title} — ${item.place}`;
        button.addEventListener('click', () => {
          item.card.hidden = false;
          item.card.scrollIntoView({ behavior: 'smooth', block: 'center' });
          item.card.classList.remove('is-highlighted'); void item.card.offsetWidth; item.card.classList.add('is-highlighted');
        });
        slot.appendChild(button);
      });
      grid.appendChild(cell);
    }
  };

  filterButtons.forEach((button) => button.addEventListener('click', () => {
    activeFilter = button.dataset.calendarFilter;
    filterButtons.forEach((item) => item.classList.toggle('is-active', item === button));
    eventCards.forEach((item) => { item.hidden = activeFilter !== 'all' && item.dataset.eventType !== activeFilter; });
    render();
  }));
  calendar.querySelector('[data-calendar-prev]')?.addEventListener('click', () => { cursor.setMonth(cursor.getMonth() - 1); render(); });
  calendar.querySelector('[data-calendar-next]')?.addEventListener('click', () => { cursor.setMonth(cursor.getMonth() + 1); render(); });
  render();
});

document.querySelectorAll('[data-add-calendar]').forEach((button) => button.addEventListener('click', () => {
  const data = button.dataset;
  const stamp = (data.date || '').replaceAll('-', '');
  const inclusiveEnd = new Date((data.endDate || data.date) + 'T12:00:00');
  inclusiveEnd.setDate(inclusiveEnd.getDate() + 1);
  const endStamp = [inclusiveEnd.getFullYear(), String(inclusiveEnd.getMonth() + 1).padStart(2, '0'), String(inclusiveEnd.getDate()).padStart(2, '0')].join('');
  const content = ['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//Raso Store//FR','BEGIN:VEVENT',`DTSTART;VALUE=DATE:${stamp}`,`DTEND;VALUE=DATE:${endStamp}`,`SUMMARY:${data.title}`,`LOCATION:${data.place || ''}`,`DESCRIPTION:${data.description || ''}`,'END:VEVENT','END:VCALENDAR'].join('\r\n');
  const link = document.createElement('a');
  link.href = URL.createObjectURL(new Blob([content], { type: 'text/calendar' }));
  link.download = `${(data.title || 'evenement').toLowerCase().replaceAll(' ', '-')}.ics`;
  link.click(); URL.revokeObjectURL(link.href);
}));


document.addEventListener('change', (event) => {
  const input = event.target.closest('[data-series-variant]');
  if (!input) return;
  const root = input.closest('[data-series-choice]');
  const form = input.closest('form');
  const hiddenId = form?.querySelector('[name="id"]');
  if (hiddenId) hiddenId.value = input.value;
  const price = document.querySelector('[data-product-price]');
  if (price && input.dataset.price) price.textContent = input.dataset.price;
  const button = form?.querySelector('[type="submit"]');
  const available = input.dataset.available === 'true';
  if (button) {
    button.disabled = !available;
    button.textContent = available ? button.dataset.availableText : button.dataset.soldoutText;
  }
  const name = root?.querySelector('[data-series-name]');
  const count = root?.querySelector('[data-series-count]');
  if (name) name.textContent = input.dataset.title || '';
  if (count) count.textContent = input.dataset.seriesIndex + ' / ' + root.querySelectorAll('[data-series-variant]').length;
  const firstImage = document.querySelector('.product-gallery .product-media img');
  if (firstImage && input.dataset.image) {
    firstImage.removeAttribute('srcset');
    firstImage.src = input.dataset.image;
  }
  const url = new URL(window.location.href);
  url.searchParams.set('variant', input.value);
  history.replaceState({}, '', url.toString());
  input.closest('.series-choice__card')?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
});

document.addEventListener('click', (event) => {
  const root = event.target.closest('[data-series-choice]');
  if (!root) return;
  const track = root.querySelector('[data-series-track]');
  if (event.target.closest('[data-series-prev]')) track?.scrollBy({ left: -(track.clientWidth * .82), behavior: 'smooth' });
  if (event.target.closest('[data-series-next]')) track?.scrollBy({ left: track.clientWidth * .82, behavior: 'smooth' });
  if (event.target.closest('[data-series-random]')) {
    const available = Array.from(root.querySelectorAll('[data-series-variant]:not(:disabled)'));
    const current = root.querySelector('[data-series-variant]:checked');
    const choices = available.length > 1 ? available.filter((item) => item !== current) : available;
    choices[Math.floor(Math.random() * choices.length)]?.click();
  }
});

document.querySelectorAll('[data-series-choice]').forEach((root) => {
  const selected = root.querySelector('[data-series-variant]:checked');
  const count = root.querySelector('[data-series-count]');
  if (selected && count) count.textContent = selected.dataset.seriesIndex + ' / ' + root.querySelectorAll('[data-series-variant]').length;
});

